/**
 * Helpers de log apenas em desenvolvimento (`npm start`).
 * Em `npm run build` / produção, `NODE_ENV === 'production'` e nada é emitido.
 */
export const IS_DEV = process.env.NODE_ENV === 'development';

export function devLog(...args: unknown[]): void {
  if (IS_DEV) console.log(...args);
}

export function devWarn(...args: unknown[]): void {
  if (IS_DEV) console.warn(...args);
}

export function devError(...args: unknown[]): void {
  if (IS_DEV) console.error(...args);
}
